import { Stack } from "@mui/material";
import MatchingTabs from "./tabs";

const Matching = () => {
  return (
    <Stack>
      <MatchingTabs />
    </Stack>
  );
};

export default Matching;
